export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 6_22.8914f95a.jpg";